module.exports = __webpack_public_path__ + "assets/Angle60DropDetailed.a8fecc42bb58d423235fc06b20fa8474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Angle60DropDetailed.png
// module id = 464
// module chunks = 0